module.exports = __webpack_public_path__ + "static/og_rents-e782332a9e6e1c11002ca7b75a153b6a.jpg";